export default __webpack_public_path__ + "static/media/skillup.5457c3f6.png";